import React, { useContext, useEffect, useState } from 'react';
import { usePropieties } from './hooks/usePropieties';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { useURLParams } from './hooks/useURLParams';
import { Arrow } from './components/UI/Arrow/Arrow';
import { Badge } from './components/UI/Badge/Badge';
import '../css/Filtros.css';
import { useFilters } from './hooks/useFilters';
import { Loading } from './components/Loading/Loading';
import { UserContext } from '../auth/context/UserContext';
import Cookies from 'universal-cookie';

export const Filtros = ({ visible, toggleFiltros }) => {
  if (!visible) return null;
  return <FiltrosContent toggleFiltros={toggleFiltros} />;
};

const FiltrosContent = ({ toggleFiltros }) => {
  const { updateParms, searchParams } = useURLParams();
  const cookies = new Cookies();

  const [originalGroups, setOriginalGroups] = useState(() => {
    const grupos = searchParams.get('grupos');
    return grupos ? new Set(grupos.split(',').map(Number)) : new Set();
  });

  const [seleccionados, setSeleccionados] = useState(() => {
    const paramFilters = searchParams.get('filters');
    return paramFilters
      ? new Set(paramFilters.split(',').map(Number))
      : new Set();
  });

  const [groupSelected, setGroupSelected] = useState(null);
  const [stock, setStock] = useState(
    Number(searchParams.get('stock')) === 1 ? 1 : 0
  );

  const { data: filterProperties, isLoading } = usePropieties();
  const { filtersCount } = useFilters();
  const { dataUser } = useContext(UserContext);
  const userData = dataUser;
  const visualizaStock = userData.visualizaStock;
  const [badgeCountState, setBadgeCountState] = useState(0);

  useEffect(() => {
    const grupos = searchParams.get('grupos');
    if (grupos) {
      setOriginalGroups(new Set(grupos.split(',').map(Number)));
      cookies.set('originalGroups', grupos, { path: '/', maxAge: 86400 });
    }
  }, []);

  const handleCheckbox = (id) => () => {
    const newSelecteds = new Set(seleccionados);
    newSelecteds.delete(id) || newSelecteds.add(id);
    setSeleccionados(newSelecteds);

    const paramSearchGrupos = searchParams.get('grupos');

    const filtersValue = Array.from(newSelecteds).join(',');

    if (paramSearchGrupos === null) {
      updateParms(['filters', filtersValue]);
    } else {
      updateParms(['grupos', filtersValue]);
    }
  };

  const handleStock = () => {
    const newStockValue = stock === 0 ? 1 : 0;
    setStock(newStockValue);
    updateParms(['stock', newStockValue]);
  };

  const toggleElement = (type) => () =>
    setGroupSelected((prevState) => (prevState === type ? null : type));

  useEffect(() => {
    const stockApplied = stock === 1;
    const totalCount = seleccionados.size + (stockApplied ? 1 : 0);
    setBadgeCountState(totalCount);
  }, [seleccionados, stock]);

  const showCleanButton = badgeCountState > 0;

  const handleCleanFilters = () => {
    setStock(0);
    setBadgeCountState(0);

    const gruposFromCookie = cookies.get('originalGroups');

    const gruposToRestore =
      gruposFromCookie || Array.from(originalGroups).join(',');

    setSeleccionados(new Set());

    const paramSearchGrupos = searchParams.get('grupos');

    let newParams;

    if (paramSearchGrupos === null) {
      newParams = ['filters', null, 'stock', null, 'pagina', 1];
    } else {
      newParams = [
        'filters',
        null,
        'stock',
        null,
        'pagina',
        1,
        'grupos',
        gruposToRestore || null,
      ];
    }

    updateParms(newParams);
  };

  return (
    <div className="filter-list">
      <div className="nav__filtros modal-content-global">
        <button type="button" onClick={() => toggleFiltros()}>
          <FontAwesomeIcon icon={faXmark} width={24} height={24} />
        </button>

        {isLoading ? (
          <Loading enabled />
        ) : (
          <div className="filters-container">
            {showCleanButton && (
              <button
                type="button"
                className="clean-filters"
                onClick={handleCleanFilters}
              >
                Borrar filtros aplicados <Badge>{badgeCountState}</Badge>
              </button>
            )}
            {filterProperties.map(({ type, properties, id }) => {
              const isOpen = groupSelected === type;
              return (
                <div
                  key={id}
                  className={`group-items ${isOpen ? 'is-open' : ''}`}
                >
                  <button
                    id="openFilter"
                    type="button"
                    onClick={toggleElement(type)}
                  >
                    <h2 htmlFor="openFilter">{type}</h2>
                    <Arrow isOpen={isOpen} />
                  </button>
                  {isOpen && (
                    <ul>
                      {properties.map((p) => (
                        <li key={p.id}>
                          <label htmlFor={p.id} className="filter-checkbox">
                            <input
                              id={p.id}
                              name={p.denomination}
                              type="checkbox"
                              checked={seleccionados.has(p.id)}
                              onChange={handleCheckbox(p.id)}
                            />
                            {p.denomination}
                          </label>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              );
            })}

            <button
              id="openFilter"
              type="button"
              onClick={toggleElement('stock')}
              style={!visualizaStock ? { display: 'none' } : undefined}
            >
              <h2 htmlFor="openFilter">Filtrar con Stock</h2>
            </button>
            <label
              htmlFor="stock"
              className="filter-checkbox"
              style={!visualizaStock ? { display: 'none' } : undefined}
            >
              <input
                id="stock"
                name="stock"
                type="checkbox"
                checked={stock}
                onChange={handleStock}
              />
              Filtrar productos con Stock
            </label>
          </div>
        )}
      </div>
      <div className="modal-background" onClick={() => toggleFiltros()}></div>
    </div>
  );
};

export default Filtros;
